module.exports = __webpack_public_path__ + "static/media/10-min.2e646ebe.png";